import { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { graphRequest } from '../msalConfig';
import SwimmingModule from './SwimmingModule';
import LiftingModule from './LiftingModule';
import WalkingModule from './WalkingModule';
import '../fitness/Fitness.css';

const ACTIVITY_TYPES = [
  { key: 'swimming', label: 'Swimming', component: SwimmingModule },
  { key: 'lifting', label: 'Lifting', component: LiftingModule },
  { key: 'walking', label: 'Walking', component: WalkingModule },
];

function Fitness() {
  const { instance, accounts } = useMsal();
  const [activeType, setActiveType] = useState('swimming');

  const getToken = async () => {
    const account = accounts[0];
    if (!account) throw new Error('Not signed in');
    const response = await instance.acquireTokenSilent({ ...graphRequest, account });
    return response.accessToken;
  };

  const userEmail = accounts[0]?.username || '';
  const ActiveComponent = ACTIVITY_TYPES.find(t => t.key === activeType)?.component;

  return (
    <div className="Fitness">
      <h1 className="Fitness-title">Fitness</h1>
      <div className="Fitness-activity-tabs">
        {ACTIVITY_TYPES.map(t => (
          <button
            key={t.key}
            className={`Fitness-activity-tab${activeType === t.key ? ' Fitness-activity-tab--active' : ''}`}
            onClick={() => setActiveType(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>
      {ActiveComponent && <ActiveComponent getToken={getToken} userEmail={userEmail} />}
    </div>
  );
}

export default Fitness;
